import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import {
  ButtonDirective,
  CuiDialogService,
  DialogCloseButtonComponent,
} from '@innersource/common-ui-components';
import { TosDialComponent } from '../../utils/dialogues/tos-dial/tos-dial.component';

/** Shows company information and contact links in the About dialog. */
@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss',
  imports: [ButtonDirective, DialogCloseButtonComponent],
})
export class InfoDialogComponent {
  /** Services. */
  private readonly dialog = inject(CuiDialogService);
  private readonly dialogRef = inject(DialogRef);

  /** State. */
  readonly currentYear = new Date().getFullYear();
  readonly supportHref =
    'mailto:support@tensor-solutions.com?subject=%5BHEP%5D%20your-subject&body=Background%20Information%0D%0Ae.g.%20%22Someone%20found%20a%20bug...%22%0D%0A%0D%0A%0D%0AHow%20to%20reproduce%20the%20error%3F%0D%0Ae.g.%0D%0A%221.%20Click%20on%20x%22%0D%0A%222.%20...%22%0D%0A%0D%0AWhat%20should%20happen%3F%0D%0Ae.g.%20%22UI%20should%20display%20values%20in%20a%20table.%22%0D%0A%0D%0A%0D%0AWhat%20is%20happening%3F%0D%0Ae.g.%20%22UI%20is%20broken.%20Console%20has%20a%20lot%20of%20errors.%22%20%28also%20attach%20data%20and%20logs%20if%20applicable%29';

  /** Opens the terms dialog after closing About. */
  openTerms(): void {
    this.dialogRef.close();
    this.dialog.open(TosDialComponent, { size: 'big', ariaLabel: 'Terms of Service' });
  }
}
